import React, {useState} from 'react';
import useWithStore from "@/Hooks/useWithStore";
import Dialog from "@mui/material/Dialog";
import isEmpty from "is-empty";
import Svg from "@/Components/Svg";

const ModalAddNominal = (props) => {
    const {stores = {}, nominalRange = []} = props;
    const {modalStore = {}, giftCertificateStore = {}} = stores;
    const minNominal = nominalRange?.minNominal ?? 500;
    const maxNominal = nominalRange?.maxNominal ?? 50000;

    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');

    /**
     * Ввод суммы сертификата
     * @param e
     */
    const nominalChange = (e) => {
        setAmount(e.target.value.replace(/[^0-9]/g, ''));
    }

    /**
     * Добавление суммы сертификата
     */
    const addNominal = () => {
        const errors = validation(amount);
        setError(errors);

        if (isEmpty(errors)) {
            giftCertificateStore.addNominal(Number(amount));
            modalStore.closeModalAddNominal();
        }
    }

    /**
     * Валидация
     * @param value
     * @returns {string}
     */
    const validation = (value) => {
        let error = '';

        if (value < minNominal) {
            error = `Сумма сертификата должна быть выше ${minNominal.toLocaleString('ru-RU')}\u00A0₽`;
        }
        if (value > maxNominal) {
            error = `Сумма сертификата не должна превышать ${maxNominal.toLocaleString('ru-RU')}\u00A0₽`;
        }
        return error;
    }

    return <Dialog id={`modal`}
                   className={`modal modal__modalAddNominal`}
                   open={modalStore.flagModalAddNominal}
                   onClose={() => modalStore.closeModalAddNominal()}
                   fullWidth>
        <div className={`modal__header`}>
            <div className={`dagger-box`} onClick={() => modalStore.closeModalAddNominal()}>
                <Svg id={`dagger-close`} className={`svg__dagger-close`} />
            </div>
            <div className={`modal-title`}>Введите сумму сертификата</div>
        </div>
        <div className={`modal__body modal__body_addNominal form`}>
            <p className={`text`}>
                Сумма сертификата должна быть
                от {minNominal.toLocaleString('ru')}&nbsp;₽ до {maxNominal.toLocaleString('ru')}&nbsp;₽
            </p>
            <div className={`form__itemNew`}>
                <input name={`addNominal`}
                       type={`text`}
                       placeholder={`Введите сумму сертификата`}
                       value={amount}
                       autoComplete={`off`}
                       autoFocus={true}
                       onChange={(e) => nominalChange(e)}
                       className={`text-inputNew`}
                />
                <label className={`text-labelNew`}>Введите сумму сертификата</label>
                {!isEmpty(error) && (
                    <span className={`error-textNew`}>{error}</span>
                )}
            </div>
            <button className={`btn`} onClick={() => addNominal()}>
                Добавить
            </button>
        </div>
    </Dialog>;
}

export default useWithStore(ModalAddNominal);
